module.exports = __webpack_public_path__ + "img/sld_mccb.56070495.svg";